import { render, staticRenderFns } from "./GolfClass.vue?vue&type=template&id=725f787e"
import script from "./GolfClass.js?vue&type=script&lang=js&external"
export * from "./GolfClass.js?vue&type=script&lang=js&external"
import style0 from "./GolfClass.vue?vue&type=style&index=0&id=725f787e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports